module.exports = __webpack_public_path__ + "static/media/choithramsLayerOne.ebb336e3.png";